<wbo-edit-page #editPage [formGroup]="editPage.formGroup"
               [title]="model.data.name">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <wbo-single-select-edit-control formControlName="cardType"
                                                            [(ngModel)]="model.data.cardType"
                                                            [readonlyOnEdit]="true"
                                                            [allowClearSelectionOption]="false"
                                                            (valueChange)="cardTypeChanged()">
                                <wbo-select-options>
                                    <wbo-select-option [value]="LoyaltyCardType.STAMPS"
                                                       label="wbo.loyalty-card.edit.option.cardType.stamps">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="LoyaltyCardType.POINTS"
                                                       label="wbo.loyalty-card.edit.option.cardType.points">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.loyalty-card.edit.formation.cardAvailability',
            formControlNames: ['name', 'targetApp', 'restrictedToApp', 'membershipTypes', 'cardGroup', 'currentCard']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="cardAvailable"
                                                   [(ngModel)]="model.data.cardAvailable"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-membership-type-multi-select-edit-control formControlName="membershipTypes"
                                                                       [(ngModel)]="model.data.membershipTypes"
                                                                       [overrideRequired]="true"
                                                                       [multiObjectValueType]="true">
                        </wbo-membership-type-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="model.data.cardType === LoyaltyCardType.STAMPS">
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="cardGroup"
                                               [(ngModel)]="model.data.cardGroup"></wbo-text-edit-control>
                        <wbo-checkbox-edit-control formControlName="currentCard"
                                                   [(ngModel)]="model.data.currentCard"></wbo-checkbox-edit-control>
                    </fui-column>
                    <fui-column>
                        <fui-inline-information [title]="'wbo.loyalty-card.edit.heading.cardGroup'"
                                                [message]="'wbo.loyalty-card.edit.message.cardGroup'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.loyalty-card.edit.formation.inclusions',
            formControlNames: ['productSelection', 'properties.excludeSubCategory', 'properties.soldAsProductLine', 'properties.soldWithinCompositeProduct', 'properties.soldAsExtraIncludeDefault', 'properties.soldAsExtraExcludeDefault', 'discountedItems', 'freeItems'],
            visible: model.data.cardType === LoyaltyCardType.STAMPS
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-single-select-edit-control formControlName="productSelection"
                                                            [(ngModel)]="model.data.productSelection"
                                                            [allowClearSelectionOption]="false">
                                <wbo-select-options>
                                    <wbo-select-option [value]="LoyaltyCardProductSelection.SELLABLE"
                                                       label="wbo.loyalty-card.edit.option.productSelection.sellable">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="LoyaltyCardProductSelection.CATEGORY"
                                                       label="wbo.loyalty-card.edit.option.productSelection.category">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="LoyaltyCardProductSelection.CUSTOM_GROUP"
                                                       label="wbo.loyalty-card.edit.option.productSelection.customGroup">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                            <ng-container formGroupName="properties">
                                <wbo-sellable-single-select-edit-control
                                    *ngIf="model.data.productSelection === LoyaltyCardProductSelection.SELLABLE"
                                    formControlName="sellableId"
                                    [(ngModel)]="model.data.properties.sellableId"
                                    [overrideRequired]="true"
                                    [allowClearSelectionOption]="false"></wbo-sellable-single-select-edit-control>
                                <wbo-category-single-select-edit-control
                                    *ngIf="model.data.productSelection === LoyaltyCardProductSelection.CATEGORY"
                                    formControlName="categoryId"
                                    [(ngModel)]="model.data.properties.categoryId"
                                    [overrideRequired]="true"
                                    [allowClearSelectionOption]="false"></wbo-category-single-select-edit-control>
                                <wbo-custom-object-single-select-edit-control
                                    *ngIf="model.data.productSelection === LoyaltyCardProductSelection.CUSTOM_GROUP"
                                    [productLineContext]="true"
                                    formControlName="customObjectId"
                                    [(ngModel)]="model.data.properties.customObjectId"
                                    [overrideRequired]="true"
                                    [allowClearSelectionOption]="false"></wbo-custom-object-single-select-edit-control>
                            </ng-container>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column formGroupName="properties">
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="numberTimes"
                                                      [(ngModel)]="model.data.properties.numberTimes"></wbo-numeric-edit-control>
                            <div class="period">
                                <wbo-numeric-edit-control formControlName="testingPeriod" class="period-value"
                                                          [(ngModel)]="model.data.properties.testingPeriod"></wbo-numeric-edit-control>
                                <wbo-single-select-edit-control formControlName="testingPeriodUnit" class="period-unit"
                                                                [(ngModel)]="model.data.properties.testingPeriodUnit"
                                                                [allowClearSelectionOption]="false">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="LoyaltyCardPeriodUnit.DAYS"
                                                           label="wbo.loyalty-card.edit.option.testingPeriodUnit.days">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="LoyaltyCardPeriodUnit.WEEKS"
                                                           label="wbo.loyalty-card.edit.option.testingPeriodUnit.weeks">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="LoyaltyCardPeriodUnit.MONTHS"
                                                           label="wbo.loyalty-card.edit.option.testingPeriodUnit.months">
                                        </wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </div>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="model.data.productSelection === LoyaltyCardProductSelection.CATEGORY"
                     formGroupName="properties">
                <fui-two-columns>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="excludeSubCategory"
                                                   [(ngModel)]="model.data.properties.excludeSubCategory"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <ng-container formGroupName="properties">
                            <fui-tandem-field>
                                <wbo-checkbox-edit-control formControlName="soldAsProductLine"
                                                           [(ngModel)]="model.data.properties.soldAsProductLine"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control formControlName="soldWithinCompositeProduct"
                                                           [(ngModel)]="model.data.properties.soldWithinCompositeProduct"></wbo-checkbox-edit-control>
                            </fui-tandem-field>
                            <fui-tandem-field>
                                <wbo-checkbox-edit-control formControlName="soldAsExtraExcludeDefault"
                                                           (valueChange)="soldAsExtraExcludeDefaultChanged()"
                                                           [(ngModel)]="model.data.properties.soldAsExtraExcludeDefault"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control formControlName="soldAsExtraIncludeDefault"
                                                           (valueChange)="soldAsExtraIncludeDefaultChanged()"
                                                           [(ngModel)]="model.data.properties.soldAsExtraIncludeDefault"></wbo-checkbox-edit-control>
                            </fui-tandem-field>
                        </ng-container>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="discountedItems"
                                                       (valueChange)="discountedItemsChanged()"
                                                       [(ngModel)]="model.data.discountedItems"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="freeItems"
                                                       [readonly]="!model.data.discountedItems"
                                                       [(ngModel)]="model.data.freeItems"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.loyalty-card.edit.formation.cardPresentation',
            formControlNames: ['appCardName', 'appItemDescription', 'appGoalDescription', 'showEmpty', 'image']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-text-edit-control formControlName="appCardName"
                                                   [(ngModel)]="model.data.appCardName"></wbo-text-edit-control>
                            <wbo-checkbox-edit-control *ngIf="model.data.cardType === LoyaltyCardType.STAMPS"
                                                       formControlName="showEmpty"
                                                       [(ngModel)]="model.data.showEmpty"></wbo-checkbox-edit-control>
                            <wbo-text-edit-control *ngIf="model.data.cardType === LoyaltyCardType.POINTS"
                                                   formControlName="pointsRequiredToDisplay"
                                                   [(ngModel)]="model.data.pointsRequiredToDisplay"></wbo-text-edit-control>
                        </fui-tandem-field>
                        <fui-tandem-field>
                            <wbo-text-edit-control *ngIf="model.data.cardType === LoyaltyCardType.STAMPS"
                                                   formControlName="appItemDescription"
                                                   [(ngModel)]="model.data.appItemDescription"></wbo-text-edit-control>
                            <wbo-text-edit-control *ngIf="model.data.cardType === LoyaltyCardType.POINTS"
                                                   formControlName="pointsRequiredToRedeem"
                                                   [(ngModel)]="model.data.pointsRequiredToRedeem"
                                                   [overrideRequired]="true"></wbo-text-edit-control>
                            <wbo-text-edit-control formControlName="appGoalDescription"
                                                   [(ngModel)]="model.data.appGoalDescription"></wbo-text-edit-control>
                        </fui-tandem-field>
                        <wbo-text-edit-control formControlName="appCardThemeName"
                                               [(ngModel)]="model.data.appCardThemeName"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="image">
                            <wbo-image-edit-control formControlName="image" [(ngModel)]="model.data.image.image">
                            </wbo-image-edit-control>
                        </ng-container>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.loyalty-card.edit.formation.reward',
            formControlNames: [
                'reward.marketingCampaignName', 'reward.discount.discountId', 'reward.mixAndMarch.id',
                'reward.daysToExpire', 'reward.usageLimit', 'reward.orderAhead', 'reward.orderDelivery', 'reward.orderAtTable',
                'reward.featureOnAppMenu', 'reward.showAppQrCode', 'reward.appText1', 'reward.appText2', 'reward.image.image', 'reward.imageAutoCrop',
                'reward.products'
            ]
        }">
        <fui-rows formGroupName="reward">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="marketingCampaignName"
                                               [(ngModel)]="model.data.reward.marketingCampaignName"></wbo-text-edit-control>
                        <ng-container formGroupName="discount">
                            <wbo-discount-single-select-edit-control formControlName="discountId"
                                                                     [(ngModel)]="model.data.reward.discount.discountId"
                                                                     [objectValue]="model.data.reward.discount"></wbo-discount-single-select-edit-control>
                        </ng-container>
                        <ng-container formGroupName="mixAndMatch">
                            <wbo-mix-and-match-single-select-edit-control formControlName="id"
                                                                          [(ngModel)]="model.data.reward.mixAndMatch.id"
                                                                          [objectValue]="model.data.reward.mixAndMatch"></wbo-mix-and-match-single-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.reward.products"
                                       [title]="'wbo.loyalty-card.edit.field-set.reward.products'"
                                       [editable]="true" [removable]="true" [entityPath]="'reward.products'">
                            <wbo-sellable-edit-link-column field="sellable.name" componentPath="sellable"
                                                           [editMode]="EditMode.VIEW"></wbo-sellable-edit-link-column>
                            <wbo-numeric-column field="quantity" [editable]="true"></wbo-numeric-column>
                            <wbo-edit-grid-add-row [identifierField]="'sellableId'" [componentPath]="'sellable'"
                                                   (onAfterEntityAdded)="afterProductAdded($event)">
                                <wbo-edit-grid-add-row-quick-add>
                                    <wbo-sellable-single-select-edit-control></wbo-sellable-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search
                                        [title]="'wbo.deal.edit.grid-add.products.addProductLines'"
                                        [searchComponent]="ProductLineSearchPageComponent"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-search
                                        [title]="'wbo.deal.edit.grid-add.products.addCompositeProducts'"
                                        [searchComponent]="CompositeProductSearchPageComponent"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity
                                        [title]="'wbo.deal.edit.grid-add.products.newProductLine'"
                                        [editComponent]="ProductLineEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                                    <wbo-edit-grid-add-row-new-entity
                                        [title]="'wbo.deal.edit.grid-add.products.newCompositeProduct'"
                                        [editComponent]="CompositeProductEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row [label]="'wbo.loyalty-card.edit.field-set.reward.availability'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="daysToExpire"
                                                  [(ngModel)]="model.data.reward.daysToExpire"></wbo-numeric-edit-control>
                        <wbo-numeric-edit-control formControlName="usageLimit"
                                                  [(ngModel)]="model.data.reward.usageLimit"></wbo-numeric-edit-control>
                    </fui-column>
                    <fui-column [label]="'wbo.loyalty-card.edit.field-set.reward.orderTypes'">
                        <wbo-checkbox-edit-control formControlName="orderAhead"
                                                   [(ngModel)]="model.data.reward.orderAhead"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="orderDelivery"
                                                   [(ngModel)]="model.data.reward.orderDelivery"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="orderAtTable"
                                                   [(ngModel)]="model.data.reward.orderAtTable"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row [label]="'wbo.loyalty-card.edit.field-set.reward.presentation'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="appText1"
                                               [placeholder]="dealTitlePlaceholder"
                                               [(ngModel)]="model.data.reward.appText1"></wbo-text-edit-control>
                        <wbo-text-edit-control formControlName="appText2"
                                               [(ngModel)]="model.data.reward.appText2"></wbo-text-edit-control>
                        <ng-container formGroupName="image">
                            <wbo-image-edit-control formControlName="image"
                                                    [(ngModel)]="model.data.reward.image.image"></wbo-image-edit-control>
                        </ng-container>
                        <wbo-checkbox-edit-control formControlName="imageAutoCrop"
                                                   [(ngModel)]="model.data.reward.imageAutoCrop"></wbo-checkbox-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="featureOnAppMenu"
                                                   [(ngModel)]="model.data.reward.featureOnAppMenu"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="showTitleOnDealCard"
                                                   [(ngModel)]="model.data.reward.showTitleOnDealCard"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="showAppQrCode"
                                                   [(ngModel)]="model.data.reward.showAppQrCode"></wbo-checkbox-edit-control>
                        <wbo-boolean-radio-edit-control [bordered]="true"
                                                        [trueLabel]="'wbo.loyalty-card.edit.field.reward.showActionButtonOnDealCard.true'"
                                                        [falseLabel]="'wbo.loyalty-card.edit.field.reward.showActionButtonOnDealCard.false'"
                                                        [(ngModel)]="model.data.reward.showActionButtonOnDealCard"
                                                        formControlName="showActionButtonOnDealCard"></wbo-boolean-radio-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
